import { useContext } from "react";
import { ResourceFormContext } from "src/components/Form/ResourceFormContext.tsx";

export const useResourceFormContext = () => {
  const context = useContext(ResourceFormContext);
  if (!context) {
    throw new Error("useFormContext must be used withing FormContext.Provider");
  }
  return context;
};
